import React from 'react';
import { io } from 'socket.io-client';
import { API_URL } from '../api';

export const SocketContext = React.createContext();

export function SocketProvider({ children }) {
  const socket = React.useMemo(() => {
    return io(API_URL, {
      transports: ['websocket'],
      autoConnect: true,
    });
  }, []);

  React.useEffect(() => {
    socket.on('connect', () => {
      console.log('Connected to WebSocket server');
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}
